import { Button, Col, DatePicker, Input, Modal, Row, Select, Table,Switch } from "antd";
import React, { useEffect, useState } from "react";
import {
  CONFIG,
  INPUT_TYPE,
  KEY,
  lang,
  MODE_SCREEN,
  STYLE,
} from "../../constants/common.const";
import { Descriptions } from "antd";
import "./equipment.scss";
import { useMediaQuery } from "react-responsive";
import {
  CloseCircleOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import EquipmentContentModal from "./equipmentContentModal";
import TextArea from "antd/lib/input/TextArea";
import { renderOption } from "../../constants/utils";
import moment from "moment";
const FormInput = ({
  valueObject,
  onChange,
  type,
  refer,
  placeHolder,
  afterDate,
  beforeDate,
  disabled,
  haveEmptyOption = true,
  className="",
  ...other
}) => {
  let InputForm = null;
  switch (type) {
    case "input": {
      InputForm = (
        <div>
          <Input
            ref={refer}
            className={`${className || ''} ${valueObject.error ? STYLE.BORDER_RED : ''}`}
            value={valueObject.value}
            onChange={onChange}
            placeholder={placeHolder}
            disabled={disabled}
            suffix={other.suffix || ""}
          />
          {valueObject.message && (
            <p style={{ color: "red", margin: 0, marginTop: 10, padding: 0 }}>
              {valueObject.message}
            </p>
          )}
        </div>
      );
      break;
    }
    case "select": {
      InputForm = (
        <Select
          showSearch
          optionFilterProp="children"
          ref={refer}
          className={`${className || 'w100'} ${valueObject.error ? STYLE.BORDER_RED : 'w100'}`}
          onChange={onChange}
          value={valueObject.value}
        >
          {renderOption(valueObject.options,haveEmptyOption)}
        </Select>
      );
      break;
    }
    case "date": {
      const checkdate = (date) => {
        if (beforeDate) {
          return date.isSameOrBefore(beforeDate);
        }
        if (afterDate) {
          const affDate = moment(afterDate)
            .add(1, "days")
            .format(KEY.DATE_DEFAULT);
          return date.isSameOrAfter(affDate);
        }
        return false;
      };
      InputForm = (
        <DatePicker
          disabledDate={checkdate}
          placeholder=""
          format={KEY.DATE_DEFAULT}
          value={valueObject.value}
          className={`${valueObject.error ? STYLE.BORDER_RED : ""} w100`}
          onChange={onChange}
          disabled={disabled}
        />
      );
      break;
    }
    case "area": {
      InputForm = (
        <div>
          <TextArea
            rows={3}
            ref={refer}
            className={valueObject.error ? STYLE.BORDER_RED : ""}
            value={valueObject.value}
            onChange={onChange}
            placeholder={placeHolder}
          />
          {valueObject.message && (
            <p style={{ color: "red", margin: 0, marginTop: 10, padding: 0 }}>
              {valueObject.message}
            </p>
          )}
        </div>
      );
      break;
    }
    case "switch": {
      InputForm = (
        <div>
          <Switch
            checked={valueObject.value}
            onChange={onChange}
            className={valueObject.error ? STYLE.BORDER_RED : ""}
          />
          {valueObject.message && (
            <p style={{ color: "red", margin: 0, marginTop: 10, padding: 0 }}>
              {valueObject.message}
            </p>
          )}
        </div>
      );
      break;
    }
    default: {
      return null;
    }
  }
  return <>{InputForm}</>;
};
function EquipmentContent({
  listData = [],
  mode,
  handlechangeInput = () => {},
  disabledSave
}) {
  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });
  const [openModalTitle, setOpenModalTitle] = useState(false);
  const [currentItem, setCurrentItem] = useState("");

  // Change Input
  const changeInput = (e, item) => {
    const value = e && e.target ? e.target.value : e;
    handlechangeInput(item.key, value, item.rule, item.type);
  };
  const getValueModeView =  (item) => {
    if (item.type === INPUT_TYPE.SWITCH) {
      return item.value.value === true ? lang.YES : lang.NO;
    }
    if (item.type === INPUT_TYPE.SELECT) {
      return item.value.label || item.value.valueString;
    }
    return item.type === INPUT_TYPE.DATE
      ? item.value.valueString
      : item.customView || item.value.label || item.value.value;
  }
  const renderInput = (item) => {
    if (item.type === INPUT_TYPE.LABEL) {
      return <div style={{
        display:"flex",
        justifyContent:"space-between"
      }}>
        <span>{item.value.value}</span>
        <span>{item.suffix}</span>
      </div>
    }

    if (item.type === INPUT_TYPE.CUSTOM) {
      return item.component;
    }
    if (mode !== MODE_SCREEN.VIEW) {
      if (item.type === INPUT_TYPE.MODAL) {
        return (
          <EquipmentContentModal
          disbaledButton={item.disbaledButton}
           titleModal={item.titleModal}
            error={item.error}
            onCancel={item.onCancel}
            onOK={item.onOk}
            compo={item.modalComponent}
            value={item.value.label}
            labelButton={item.labelButton}
            disabledSave={item.disabledSave}
          ></EquipmentContentModal>
        );
      }
      return (
        <FormInput
          onChange={(e) => {
            if(item.onChangeCustom){
              item.onChangeCustom(e.target.value)
              return
            }
            changeInput(e, item);
            if (item.customChange) {
              item.customChange(e, item);
            }
          }}
          valueObject={item.value}
          disabled={item.disabled}
          refer={item.refer}
          haveEmptyOption={item.haveEmptyOption}
          className={item.disabled && "equipment-disabled-input"}
          {...item}
        />
      );
    }

    return <div style={{
      display:"flex",
      justifyContent:"space-between"
    }}>
      <span>{getValueModeView(item)}</span>
      <span>{item.suffix}</span>
    </div>
  };

  // Change title
  const changeTitle = (item) => {
    if (!item.editTitle || mode === MODE_SCREEN.VIEW) {
      return;
    }
    setCurrentItem(item);
    setOpenModalTitle(true);
  };

  // HandleOK
  const handleOkChangeTitle = () => {
    if (currentItem && currentItem.changeTitle) {
      currentItem.changeTitle(currentItem.title);
    }
    setOpenModalTitle(false);
  };

  const renderDescriptions = (list) => {
    return (
      <Descriptions className="customEquipmentDes" size="small" column={2} bordered>
        {list.map((item, index) => (
          <Descriptions.Item
            style={{ width: item.span == 1 ? "30%" : "80%",display:item.isNone ? "none" :"" }}
            labelStyle={{
              width: "20%",
              fontWeight: "bold",
              // display:item.hideTitle && "none"
              background: item.hideTitle && "#fff",
              borderRight: item.hideTitle && "none",
            }}
            contentStyle={{ padding: "4px 4px" }}
            key={index}
            label={
              <div
                onClick={() => changeTitle(item)}
                style={{
                  cursor: item.editTitle && "pointer",
                  color:  item.required && "#ff2255",
                }}
                className="labelInputEquipment"
              >
                {item.title}
              </div>
            }
            span={item.span || 1}
          >
            {renderInput(item)}
          </Descriptions.Item>
        ))}
      </Descriptions>
    );
  };

  return (
    <div>
      {renderDescriptions(listData)}

      <Modal
        centered
        width={isPC ? 600 : "90%"}
        closeIcon={<></>}
        className=""
        title={null}
        getContainer={false}
        visible={openModalTitle}
        onCancel={() => setOpenModalTitle(false)}
        footer={
          <Row>
            <Col span={20} style={{ textAlign: "right" }}>
              <Button
              disabled={disabledSave}
                key={1}
                className="buttonPC button--info wAuto"
                onClick={() => {
                  handleOkChangeTitle();
                }}
              >
                {lang.OK}
              </Button>
              <Button
                onClick={() => setOpenModalTitle(false)}
                className="buttonPC --todo-- wAuto  button--outline"
              >
                {lang.CANCEL}
              </Button>
            </Col>
          </Row>
        }
      >
        <div className="bold mb5">{lang.TITLE}</div>
        <Input
          onChange={(e) =>
            setCurrentItem({ ...currentItem, title: e.target.value })
          }
          value={currentItem.title}
        />
      </Modal>
    </div>
  );
}

export default EquipmentContent;
